import { Component, ChangeDetectorRef } from "@angular/core";
import { ICellRendererAngularComp } from "@ag-grid-community/angular";

import {
  NgbModal,
  ModalDismissReasons,
  NgbModalConfig,
} from "@ng-bootstrap/ng-bootstrap";
import { HttpService } from "../../service/HTTPService/HttpService";
import { environment } from "../../../environments/environment";
import { BindingURLService } from "../../service/Bindingurlservice/binding-url.service";

import { Globals } from "../../globals";
import $ from "jquery";
import { ApiService } from "../../service/apiUrls/apiUrl.service";

@Component({
  selector: "app-actions-cell",
  template: ` <div>
      <div id="loader"></div>
    </div>
    <div id="alarmRenderer">
      <div
        id="detailedsiteList"
        style="color: #007bff;
                text-decoration: none;
                background-color: transparent;"
        (click)="siteAccessClickFunction(content, sid)"
      >
        {{ siteAccessStatus }}
      </div>

      <ng-template #content let-modal>
        <div class="modal-header">
          <h5 class="modal-title" id="modal-basic-title">Site Access</h5>
          <button
            type="button"
            class="close"
            aria-label="Close"
            (click)="modal.dismiss('Cross click')"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          {{ getReponse }}
        </div>
      </ng-template>
    </div>`,
  styles: [
    `
      .loading {
        position: fixed;
        top: 0px;
        left: 0;
        z-index: 1050;
        width: 100%;
        height: 100%;
        outline: 0;
        transition: opacity 0.15s linear;
        display: block !important;
        overflow-x: hidden;
        overflow-y: auto;
      }
    `,
  ],
})
export class SiteListAccessRendererComponent
  implements ICellRendererAngularComp
{
  public params: any;
  public colors = "";
  public width = "";
  public height = "";
  public sid = "";
  public siteAccessStatus;
  public link = "";
  getReponse;
  closeResult: string;
  constructor(
    private modalService: NgbModal,
    private globals: Globals,
    private cdr: ChangeDetectorRef,
    config: NgbModalConfig,
    private http: HttpService,
    private urlAuthentication: BindingURLService,
    private apiUrl: ApiService
  ) {
    config.backdrop = "static";

  }

  agInit(params: any): void {
    let priority = "";
    this.colors = "";
    this.params = params;
    this.sid = this.params.data.SiteCode;
    this.siteAccessStatus = this.params.data.AccessStatus;
  }
  refresh(): boolean {
    return false;
  }
  /**
   * To open the Export Modal
   * @param content
   */
  siteAccessClickFunction(content, id) {
    this.http
      .get(
        this.urlAuthentication.itocUrl +
          this.apiUrl.siteAccessLink +
          "" +
          this.sid
      )
      .subscribe(
        (res) => {
          const getResp: string = JSON.stringify(res);
          const resp = JSON.parse(getResp);
          this.getReponse = resp;
          this.openFunction(content);
        },
        (error) => {
          console.error(error);
        }
      );
  }
  openFunction(content) {
    this.modalService
      .open(content, { ariaLabelledBy: "modal-basic-title" })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }
}
